/**
 * chinese
 */
export const list_range = [
	[
		"〇",
		"一",
		"二",
		"三",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九",
		"十"
	],
	[
		"零",
		"一",
		"二",
		"三",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九",
		"十"
	],
	[
		"〇",
		"一",
		"二",
		"三",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九",
		"十"
	],
	[
		"〇",
		"壱",
		"弐",
		"参",
		"四",
		"五",
		"六",
		"七",
		"八",
		"九",
		"十"
	],
	[
		"零",
		"壱",
		"弐",
		"参",
		"肆",
		"伍",
		"陸",
		"柒",
		"捌",
		"玖",
		"拾"
	],
	[
		"零",
		"壹",
		"貳",
		"參",
		"肆",
		"伍",
		"陸",
		"柒",
		"捌",
		"玖",
		"拾"
	],
	[
		"零",
		"壹",
		"贰",
		"叁",
		"肆",
		"伍",
		"陆",
		"柒",
		"捌",
		"玖",
		"拾"
	],
	[
		"零",
		"壱",
		"弐",
		"参",
		"肆",
		"伍",
		"陸",
		"柒",
		"捌",
		"玖",
		"什"
	],
	[
		"零",
		"壹",
		"貳",
		"參",
		"肆",
		"伍",
		"陸",
		"柒",
		"捌",
		"玖",
		"什"
	],
	[
		"零",
		"壹",
		"贰",
		"叁",
		"肆",
		"伍",
		"陆",
		"柒",
		"捌",
		"玖",
		"什"
	]
];

/**
 * chinese2
 */
export const list_range2 = [
	[
		"洞",
		"幺",
		"两",
		"三",
		"刀",
		"五",
		"六",
		"拐",
		"八",
		"勾"
	]
];

export default list_range;

